<template>
  <fieldset>
    <legend>{{ t("app-program-vetting") }}</legend>
    <div class="ui-form-row">
      <app-radios v-model="program.attributes.programScreensMentors"
                  name="program-screens-mentors"
                  :label='t("app-program-screens-mentors")'
                  :options="optionsYesNoNotApplicable"
      />
    </div>
    <div class="ui-form-row" v-if="program.attributes.programScreensMentors === 'yes'">
      <checkboxes v-model="program.attributes.programScreensMentorsHow"
                  :label='t("app-program-screens-mentors-how")'
                  :options="optionsScreensMentorsHow"
                  :cols="2"
      />
    </div>
    <div class="ui-form-row">
      <app-radios v-model="program.attributes.programScreensMentees"
                  name="program-screens-mentees"
                  :label='t("app-program-screens-mentees")'
                  :options="optionsYesNoNotApplicable"
      />
    </div>
    <div class="ui-form-row" v-if="program.attributes.programScreensMentees === 'yes'">
      <checkboxes v-model="program.attributes.programScreensMenteesHow"
                  :label='t("app-program-screens-mentees-how")'
                  :options="optionsScreensMenteesHow"
                  :cols="2"
      />
    </div>
    <div class="ui-form-row">
      <app-radios v-model="program.attributes.programProvidesPreMatchTrainingToMentors"
                  name="program-provides-pre-match-training-to-mentors"
                  :label='t("app-program-provides-pre-match-training-to-mentors")'
                  :options="optionsYesNoNotApplicable"
      />
    </div>
    <div class="ui-form-row col-2" v-if="program.attributes.programProvidesPreMatchTrainingToMentors === 'yes'">
      <checkboxes v-model="program.attributes.programProvidesPreMatchTrainingToMentorsDeliveredHow"
                  :label='t("app-program-provides-pre-match-training-to-mentors-how")'
                  :options="optionsProvidesPreMatchTrainingToMentorsDeliveredHow"
      />
      <app-radios v-model="program.attributes.programProvidesPreMatchTrainingToMentorsMandatory"
                  name="program-provides-pre-match-training-to-mentors-mandatory"
                  :label='t("app-program-provides-pre-match-training-to-mentors-mandatory")'
                  :options="optionsYesOrNo"
      />
    </div>
    <div class="ui-form-row">
      <app-radios v-model="program.attributes.programProvidesPreMatchTrainingToMentees"
                  name="program-provides-pre-match-training-to-mentees"
                  :label='t("app-program-provides-pre-match-training-to-mentees")'
                  :options="optionsYesNoNotApplicable"
      />
    </div>
    <div class="ui-form-row col-2" v-if="program.attributes.programProvidesPreMatchTrainingToMentees === 'yes'">
      <checkboxes v-model="program.attributes.programProvidesPreMatchTrainingToMenteesDeliveredHow"
                  :label='t("app-program-provides-pre-match-training-to-mentees-how")'
                  :options="optionsProvidesPreMatchTrainingToMenteesDeliveredHow"
      />
      <app-radios v-if="program.attributes.programProvidesPreMatchTrainingToMentees === 'yes'"
                  v-model="program.attributes.programProvidesPreMatchTrainingToMenteesMandatory"
                  name="program-provides-pre-match-training-to-mentees-mandatory"
                  :label='t("app-program-provides-pre-match-training-to-mentees-mandatory")'
                  :options="optionsYesOrNo"
      />
    </div>
    <div class="ui-form-row">
      <checkboxes v-model="program.attributes.programHowDoesYourProgramMatchMentorsToMentees"
                  :label='t("app-program-how-does-your-program-match-mentors-to-mentees")'
                  :options="optionsHowDoesYourProgramMatchMentorsToMentees"
                  :cols="2"
      />
    </div>
    <div class="ui-form-row" v-if="program.attributes.programHowDoesYourProgramMatchMentorsToMentees.findIndex(row => row.value === 'other') !== -1">
      <app-input v-model="program.attributes.programHowDoesYourProgramMatchMentorsToMenteesExplainHow"
                 type="text"
                 :label="t('app-no-formal-matching-please-explain')"
                 :required="true"
      />
    </div>
    <div class="ui-form-row">
      <app-radios v-model="program.attributes.programDoesYourProgramProvideOngoingMonitoringAndSupportToTheMentoringRelationship"
                  name="program-does-your-program-provide-ongoing-monitoring-and-support-to-the-mentoring-relationship"
                  :label='t("app-does-your-program-provide-ongoing-monitoring-and-support-to-the-mentoring-relationship")'
                  :options="optionsYesNoNotApplicable"
      />
    </div>
    <div class="ui-form-row">
      <app-radios v-model="program.attributes.programIsThereAFormalBeginningAndEndToTheMentoringRelationship"
                  name="program-is-there-a-formal-beginning-and-end-to-the-mentoring-relationship"
                  :label='t("app-is-there-a-formal-beginning-and-end-to-the-mentoring-relationship")'
                  :options="optionsYesNoNotApplicable"
      />
    </div>
    <div class="ui-form-row">
      <app-radios v-model="program.attributes.programDoesYourProgramHaveSpecificGoalsOrOutcomes"
                  name="program-does-your-program-have-specific-goals-or-outcomes"
                  :label='t("app-does-your-program-have-specific-goals-or-outcomes")'
                  :options="optionsYesNoNotApplicable"
      />
    </div>
    <div class="ui-form-row" v-if="program.attributes.programDoesYourProgramHaveSpecificGoalsOrOutcomes === 'yes'">
      <checkboxes v-model="program.attributes.programDoesYourProgramHaveSpecificGoalsOrOutcomesWhich"
                  :label='t("app-does-your-program-have-specific-goals-or-outcomes-which")'
                  :options="optionsDoesYourProgramHaveSpecificGoalsOrOutcomesWhich"
                  :cols="3"
      />
    </div>
    <div class="ui-form-row" v-if="program.attributes.programDoesYourProgramHaveSpecificGoalsOrOutcomes === 'yes' && program.attributes.programDoesYourProgramHaveSpecificGoalsOrOutcomesWhich.findIndex(row => row.value === 'other') !== -1">
      <app-input type="text"
                 v-model="program.attributes.programDoesYourProgramHaveSpecificGoalsOrOutcomesWhichOther"
                 :label="t('app-does-your-program-have-specific-goals-or-outcomes-which-other')"
                 :required="true"
      />
    </div>
    <div class="ui-form-row">
      <fieldset>
        <legend>{{ t("app-feedback-legend") }}</legend>
        <app-textarea
            v-model="program.attributes.feedback"
            :label="t('app-feedback-label')"
            id="program-feedback"
        />
      </fieldset>
    </div>
  </fieldset>
</template>

<script lang="ts">
import BaseMixin from "BaseMixin"

export default {
  props: ['program'],
  mixins: [BaseMixin],

  data() {
    return {
      optionsYesNoNotApplicable: [
        {value: 'yes', name: this.t('app-yes')},
        {value: 'no', name: this.t('app-no')},
        {value: 'not-applicable', name: this.t('app-not-applicable')},
      ],
      optionsScreensMentorsHow: [
        {value: 'app-mentors-must-complete-an-application', name: this.t('app-mentors-must-complete-an-application')},
        {value: 'app-mentors-must-provide-references', name: this.t('app-mentors-must-provide-references')},
        {
          value: 'app-mentors-must-provide-a-criminal-background-check',
          name: this.t('app-mentors-must-provide-a-criminal-background-check')
        },
        {
          value: 'app-mentors-must-provide-a-vulnerable-sector-check',
          name: this.t('app-mentors-must-provide-a-vulnerable-sector-check')
        },
        {
          value: 'app-mentors-must-provide-a-child-and-family-services-background-check',
          name: this.t('app-mentors-must-provide-a-child-and-family-services-background-check')
        },
        {
          value: 'app-mentors-must-attend-an-interview-with-program-staff',
          name: this.t('app-mentors-must-attend-an-interview-with-program-staff')
        },
      ],
      optionsScreensMenteesHow: [
        {value: 'app-mentees-must-complete-an-application', name: this.t('app-mentees-must-complete-an-application')},
        {
          value: 'app-mentees-must-be-referred-to-the-program',
          name: this.t('app-mentees-must-be-referred-to-the-program')
        },
        {
          value: 'app-mentees-must-attend-an-interview-with-program-staff',
          name: this.t('app-mentees-must-attend-an-interview-with-program-staff')
        },
      ],
      optionsProvidesPreMatchTrainingToMentorsDeliveredHow: [
        {value: 'app-in-person', name: this.t('app-in-person')},
        {value: 'app-online-virtual', name: this.t('app-online-virtual')},
        {value: 'app-hardcopy-manual', name: this.t('app-hardcopy-manual')},
      ],
      optionsYesOrNo: [
        {value: 'yes', name: this.t('app-yes')},
        {value: 'no', name: this.t('app-no')},
      ],
      optionsProvidesPreMatchTrainingToMenteesDeliveredHow: [
        {value: 'app-in-person', name: this.t('app-in-person')},
        {value: 'app-online-virtual', name: this.t('app-online-virtual')},
        {value: 'app-hardcopy-manual', name: this.t('app-hardcopy-manual')},
      ],
      optionsHowDoesYourProgramMatchMentorsToMentees: [
        {value: 'app-manual-matching-by-program-staff', name: this.t('app-manual-matching-by-program-staff')},
        {
          value: 'app-manual-matching-by-school-or-third-party',
          name: this.t('app-manual-matching-by-school-or-third-party')
        },
        {value: 'app-random-matching', name: this.t('app-random-matching')},
        {value: 'app-youth-initiated-mentoring', name: this.t('app-youth-initiated-mentoring')},
        {value: 'app-technologically-assisted-matching', name: this.t('app-technologically-assisted-matching')},
        {value: 'app-no-formal-matching', name: this.t('app-no-formal-matching')},
        {value: 'other', name: this.t('app-other')}
      ],
      optionsDoesYourProgramHaveSpecificGoalsOrOutcomesWhich: [
        {value: 'app-ca-academic-enrichment', name: this.t('app-ca-academic-enrichment')},
        {value: 'app-ca-bullying-prevention', name: this.t('app-ca-bullying-prevention')},
        {
          value: 'app-ca-career-exploration-job-readiness-employability',
          name: this.t('app-ca-career-exploration-job-readiness-employability')
        },
        {value: 'app-ca-job-placement', name: this.t('app-ca-job-placement')},
        {value: 'app-ca-civic-engagement', name: this.t('app-ca-civic-engagement')},
        {
          value: 'app-ca-post-secondary-access-and-or-completion',
          name: this.t('app-ca-post-secondary-access-and-or-completion')
        },
        {
          value: 'app-ca-educational-attainment-direct-academic-support',
          name: this.t('app-ca-educational-attainment-direct-academic-support')
        },
        {value: 'app-ca-family-support', name: this.t('app-ca-family-support')},
        {value: 'app-ca-positive-youth-development', name: this.t('app-ca-positive-youth-development')},
        {value: 'app-ca-identity-development', name: this.t('app-ca-identity-development')},
        {value: 'app-ca-indigenous-identity-development', name: this.t('app-ca-indigenous-identity-development')},
        {value: 'app-ca-juvenile-justice-re-entry', name: this.t('app-ca-juvenile-justice-re-entry')},
        {value: 'app-ca-leadership-development', name: this.t('app-ca-leadership-development')},
        {value: 'app-ca-life-skills', name: this.t('app-ca-life-skills')},
        {value: 'app-ca-social-emotional-learning', name: this.t('app-ca-social-emotional-learning')},
        {value: 'app-ca-literacy', name: this.t('app-ca-literacy')},
        {value: 'app-ca-mental-health-and-wellbeing', name: this.t('app-ca-mental-health-and-wellbeing')},
        {value: 'app-ca-positive-health-behaviours', name: this.t('app-ca-positive-health-behaviours')},
        {value: 'app-ca-pregnancy-prevention', name: this.t('app-ca-pregnancy-prevention')},
        {value: 'app-ca-developmental-relationship', name: this.t('app-ca-developmental-relationship')},
        {value: 'app-ca-recreational-activities-hobbies', name: this.t('app-ca-recreational-activities-hobbies')},
        {value: 'app-ca-resiliency', name: this.t('app-ca-resiliency')},
        {value: 'app-ca-stem', name: this.t('app-ca-stem')},
        {value: 'app-ca-substance-use', name: this.t('app-ca-substance-use')},
        {value: 'app-ca-violence-prevention-reduction-in-aggression', name: this.t('app-ca-violence-prevention-reduction-in-aggression')},
        {value: 'other', name: this.t('app-other')}
      ]
    }
  }
}
</script>